var _effectorFileName = "/builds/gmini/front-utils/src/useWindowEventListener.ts";
import * as React from 'react';
export function useWindowEventListener(type, listener, options) {
  React.useEffect(function () {
    window.addEventListener(type, listener, options);
    return function () {
      return window.removeEventListener(type, listener, options);
    };
  }, [listener, options, type]);
}
export var useWindowEL = useWindowEventListener;